import React, { Component } from 'react';
import { reset, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FieldItems from 'components/shared/FieldItems/FieldItems';
import AddApplicantForm from './AddApplicantForm';
import SavedApplicants from './SavedApplicants';

import { addOrEditApplicant, deleteApplicant } from 'actions/tenantApplicationActions';
import { getTenancyStatus } from 'actions/dashboardActions';
import { getApplicationStatus } from 'actions/applicationStatusActions';
import { getTenantTodoList } from 'actions/todoActions';

let AddExtraApplicantsForm = class extends Component {
  addOrEditApplicant = async formData => {
    await this.props.addOrEditApplicant(formData, this.props.applicationID);
    this.props.getApplicationStatus();
    this.props.getTenantTodoList();
    await this.props.getTenancyStatus();
    this.props.reset('add_applicants');
  };

  deleteApplicant = async formData => {
    await this.props.deleteApplicant(formData.id, this.props.applicationID);
    this.props.getApplicationStatus();
    this.props.getTenantTodoList();
    await this.props.getTenancyStatus();
    this.props.reset('add_applicants');
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <form onSubmit={handleSubmit}>{this.renderFieldItems()}</form>
      </div>
    );
  }

  renderFieldItems = () => {
    return (
      <FieldItems
        name="applicants"
        formName={this.props.form}
        renderSavedItems={SavedApplicants}
        renderForm={AddApplicantForm}
        dialogHeader="Add Applicant"
        buttonVerbiageOverride="Add Applicant"
        onSave={formData => this.addOrEditApplicant(formData)}
        onDelete={formData => this.deleteApplicant(formData)}
      />
    );
  };
};

AddExtraApplicantsForm = connect(
  store => ({
    applicationID: store.dashboard.activeApplicationID,
  }),
  {
    addOrEditApplicant,
    deleteApplicant,
    getTenancyStatus,
    reset,
    getApplicationStatus,
    getTenantTodoList,
  }
)(AddExtraApplicantsForm);

AddExtraApplicantsForm = reduxForm({
  form: 'add_applicants',
  enableReinitialize: true,
})(AddExtraApplicantsForm);

export default AddExtraApplicantsForm;
